<template>
  <div class="user-study-questions-container">
    <div v-for="(q, index) in content" :key="index" class="mb-7 mt-7">
      <div
        v-if="q.studyQuestionStatement"
        v-html="q.studyQuestionStatement"
        class="study-question-statement mb-7 pt-7"
      ></div>

      <div
        v-html="q.studyQuestion"
        class="mb-3 font-weight-bold question"
      ></div>

      <v-textarea
        :id="'studyQuestion-' + index"
        v-model="q.studyQuestionAnswer"
        auto-grow
        variant="filled"
        :rows="areaSize(q.studyQuestionResponseLines)"
        row-height="24px"
        placeholder=""
        hide-details="auto"
        color="green"
        disabled
        class="mb-7"
      >
        <template #label>
          <PencilIcon :color="iconColor" class="pencil-icon" />
        </template>
      </v-textarea>
      <v-card-text
        v-if="q.studyQuestionResourceURL"
        class="pa-0 pt-2 text-subtitle-2 font-weight-bold text-uppercase"
        >Additional Resource</v-card-text
      >
      <v-chip
        v-if="q.studyQuestionResourceLabel"
        :href="q.studyQuestionResourceURL"
        target="_blank"
        color="#a5d867"
        size="small"
        class="font-weight-bold btn-multiline mb-1 btn-multiline"
      >
        {{ q.studyQuestionResourceLabel }}
      </v-chip>
      <v-list-item v-else :href="q.studyQuestionResourceURL" target="_blank">
        {{ q.studyQuestionResourceURL }}
      </v-list-item>
    </div>
  </div>
</template>

<script>
  import PencilIcon from '@/assets/icons/PencilIcon.vue'
  import { currentTheme } from '@/plugins/vuetify'

  export default {
    name: 'UserStudyQuestions',
    props: ['content', 'section', 'unitbackdoor'],
    components: {
      PencilIcon,
    },
    data() {
      return {
        studyQuestionStatement: '',
        studyQuestion: '',
        studyQuestionResponseLines: '',
        studyQuestionResourceLabel: '',
        studyQuestionResourceURL: '',
      }
    },
    computed: {
      iconColor() {
        return currentTheme.value === 'dark' ? '#cecece' : '#383935'
      },
    },
    methods: {
      areaSize(size) {
        if (size == 'short') return 2
        if (size == 'medium') return 4
        if (size == 'long') return 6

        return false
      },
    },
  }
</script>

<style scoped>
  .user-study-questions-container :deep(label svg) {
    opacity: 0.55;
  }
  .v-input:not(.v-input--is-focused) :deep(.v-input__slot fieldset) {
    border-color: transparent;
  }
  .snippet-autosave-status {
    display: none;
  }
  .active + .snippet-autosave-header .snippet-autosave-status {
    display: flex;
  }
  .archived {
    background: rgba(0, 0, 0, 0.06);
    padding: 12px;
    border-radius: 4px;
    min-height: 56px;
    align-items: center;
    display: flex;
  }
  .question.pdf {
    padding-top: 12px;
    margin-bottom: 0px !important;
  }
  .archived.pdf {
    background: transparent;
    font-style: italic;
  }
  .study-question-statement {
    page-break-inside: avoid;
    break-inside: avoid;
  }
</style>
